import styled from 'styled-components'
import { sureco } from '../shared/finance.styles'

export const DrawClientName = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${sureco.fg1};
`

export const DrawAmountLine = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${sureco.fg1};
`

export const DrawWarningText = styled.div`
  font-size: 13px;
  color: ${sureco.fg3};
  margin: 10px 0 18px;
  line-height: 1.5;
`

export const SplitSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`

export const SplitSectionLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${sureco.fg3};
`

export const AllocationStatus = styled.span<{ $ok: boolean }>`
  font-size: 13px;
  font-weight: 600;
  color: ${({ $ok }) => ($ok ? '#0d9488' : '#dc2626')};
`

export const DrawRowList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const DrawRowCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid ${sureco.border};
  border-radius: 10px;
`

export const DrawRowInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`

export const DrawRowName = styled.div<{ $isWarning?: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ $isWarning }) => ($isWarning ? '#b45309' : sureco.fg1)};
`

export const DrawRowId = styled.div`
  font-size: 12px;
  color: ${sureco.fg3};
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
`

export const DrawRowInputWrap = styled.div`
  flex-shrink: 0;
  width: 160px;
`

export const AllocationFooterNote = styled.div`
  font-size: 12px;
  color: ${sureco.fg3};
  margin-top: 10px;
`

export const AllocationErrorNote = styled.div`
  font-size: 12px;
  color: #dc2626;
  margin-top: 6px;
`
